export const HEIGHT_VALID_RANGE_METRIC = { min: 50, max: 274 }
export const WEIGHT_VALID_RANGE_METRIC = { min: 30, max: 500 }

export const HEIGHT_VALID_RANGE_IMPERIAL = { min: 1, max: 9 }
export const WEIGHT_VALID_RANGE_IMPERIAL = { min: 4, max: 79 }

export const STEP_ELEMENT_ID_PREFIX = 'programme-form-step'
export const PREFILL_EMAIL_KEY = 'programme-form-prefill-email'
